export const erpLogClstag = {
  mainGoodBtnClick: 'pageclick|keycount|yx_center_1629184833805|6',
  searchBtnClick: 'pageclick|keycount|yx_center_1629184833805|78',
  saveBtnClick: 'pageclick|keycount|yx_center_1629184833805|2',
  editBtnClick: 'pageclick|keycount|yx_center_1629184833805|4',
  mutSaveBtnClick: 'pageclick|keycount|yx_center_1629184833805|3',
  changePicClick: 'pageclick|keycount|yx_center_1629184833805|5',
  batchApplyClick: 'pageclick|keycount|yx_supplement_material_1667531069355|1',
  batchModalOkClick: 'pageclick|keycount|yx_supplement_material_1667531069355|2',
  batchModalCancelClick: 'pageclick|keycount|yx_supplement_material_1667531069355|3',
}
